<template>
  <div class="add_teacher">
    <el-card class="box-card">
      <el-form
        ref="addFromRef"
        :model="addFrom"
        :rules="addFromRules"
        label-width="110px"
      >
        <el-form-item label="标题:">
          {{ addFrom.title }}
        </el-form-item>
        <el-form-item label="是否提现:" prop="info">
          <!-- 单选 -->
          <el-radio-group v-model="addFrom.info">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
          <!-- <div> 外部店长提现设置 0 否 1 是</div> -->
        </el-form-item>

        <el-form-item>
          <el-button type="success" @click="submitForm">保存</el-button>
          <!-- <el-button type="primary" @click="goBack">返回</el-button> -->
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import { getBaseSet, outBaseSet ,InBaseSet} from "../../api/administrator.js";
export default {
  data() {
    return {
      addFrom: {
        info: 0,
        title: "",
        // teacherId: 0,
        // teacherName: "",
        // phone: "",
        // headImgUrl: "",
        // details: "",
      },

      addFromRules: {
        info: [{ required: true, message: "请选择是否提现", trigger: "blur" }],
      },
      type:''
    };
  },
  created() {
    this.type = this.$route.query.type
    this.getBase();
  },
  watch: {
    $route(to, from) {
      this.type = this.$route.query.type;
      this.getBase();
    },
  },
  methods: {
    getBase() {
      getBaseSet({ id: this.type=='external'?1:4 }).then((res) => {
        if (res.data.code == 0) {
          this.addFrom.title = res.data.data.title;
          this.addFrom.info = res.data.data.info;
        }
      });
    },
    submitForm() {
      this.$refs.addFromRef.validate(async (validate) => {
        if (!validate) return;
        if (this.isSubmit) return;
        this.isSubmit = true;
        let demaed = this.type =='external'?outBaseSet:InBaseSet
        const { data } = await demaed({ info: this.addFrom.info });
        this.isSubmit = false;
        if (data.code == 0) {
          //   this.goBack();
          this.getBase();
          this.$message.success(data.msg);
        } else {
          this.getBase();
          this.$message.warning(data.msg);
        }
      });
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.avatar-uploader-icon {
  border: 1px dashed #eee;
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 150px;
  height: 150px;
}
.box-card {
  padding-bottom: 50px;
}
</style>
